







import { Component, Vue, Prop } from 'vue-property-decorator';
import { ISprint } from '@/lib/interfaces';

@Component
export default class SprintOption extends Vue {
  @Prop() private option!: ISprint;
}
